import Image from 'next/image'

import { type PortableTextBlock } from 'next-sanity'

import { buttonSizeClasses } from '@/app/components/Button'
import PortableText from '@/app/components/PortableText'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { CtaSection as CtaSectionProps } from '@/sanity.types'

type CtaProps = {
  block: CtaSectionProps & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
}

export default function CtaSection({ block, pageId, pageType }: CtaProps) {
  return (
    <div className="content-container mt-7xl mb-4xl md:mb-5xl lg:mt-11xl">
      <div className="relative z-1 overflow-hidden bg-neutral-50 rounded-md p-2xl md:p-5xl lg:py-9xl">
        <Image
          src="/images/ctaBackground.png"
          alt=""
          fill
          sizes="(max-width: 768px) 640px, (max-width: 1024px) 768px, 100vw"
          className="object-cover object-center -z-1"
          quality={75}
          priority={false}
        />
        {block?.content?.length && (
          <PortableText
            className={cn(
              'flex flex-col items-center justify-center text-center relative z-1',
              'mx-auto max-w-[208px] md:max-w-none',
            )}
            tracking={{ location: TRACKING_LOCATIONS.CTA }}
            buttonClassName={buttonSizeClasses({ lg: 'lg' })}
            value={block.content as PortableTextBlock[]}
            documentId={pageId}
            documentType={pageType}
            parentPath={block._key ? `pageBuilder[_key=="${block._key}"].content` : undefined}
          />
        )}
      </div>
    </div>
  )
}
